import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDto } from '@cradua/data';
import { IdentityUser, User } from '@cradua/domain';
import { AuthenticationService } from 'apps/epims/mrsoftepims/src/app/services/auth.service';
import { GatewayService } from 'libs/gateway/src/lib/services/gateway.service';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { AuthService } from '../../services/auth.service';

import Swal from 'sweetalert2';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangepasswordComponent implements OnInit {
  changePassowrdform: FormGroup;
  Users: IdentityUser[] = [];
  User: IdentityUser;
  userMain: User;
  submitted = false;

  passwordMissMatch: boolean = false;

  password: string = '';
  confirmedPassword: string = '';

  
  userUpdate: UserDto = {
    
    id: '',
	Id: '',
	UserName: '',
	PhoneNo: '',

	password: '',

	Email: '',
	UserType: '',
	SubscriberName: '',
	FirstName: '',
	LastName: '',
	MiddleName: '',
	StaffName: '',
	Logo: '',
	VerifyStatus: '',
	IsConfirmed: '',
	UIN: '',
	NewUser: '',
	spouseName: '',
	noOfChildren: 0,
	address: '',
	gender: '',
	ocupation: '',
	userRole: '',
	slogan: '',
	siteId: '',
	siteName: '',
	siteNumber: '',
	levelCount: 0,
	canAddSub: false,
	siteGenericNumber: '',
	systemAdminStatus: '',
	resetPasswordToken: '',
	resetPasswordExpires: new Date(),
  ParentId: '',
  SubscriberId: '',
  SiteId: '',
  ModifiedById: '',
  };
  constructor(private fb: FormBuilder, private route: ActivatedRoute, private gatewayFacade: GatewayFacade,public gatewayService: GatewayService,public authService: AuthService,
    private _router: Router, public authServ: AuthenticationService) { }

  ngOnInit() {

    this.userMain = this.authServ.getUser();

    this.changePassowrdform = this.fb.group({
     
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    
  }, {
      validator: this.MustMatch('password', 'confirmPassword')
  });

  }


  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

formInputChange(){
  this.submitted = false;
}

   changePassword(){

    this.submitted = true;

    // stop here if form is invalid
    if (this.changePassowrdform.invalid) {

      console.log("Not Valid ");
     return;
 }

 this.password = this.changePassowrdform.value.password;
 this.confirmedPassword = this.changePassowrdform.value.confirmPassword;

 if(this.password !== '')
 {
   console.log("Password is not empty ", this.confirmedPassword, this.password);
   if(this.confirmedPassword === this.password)
   {

    // let password = "ThankYouJesus";

    console.log("Reaching Click ");


      
    this.gatewayService.getUserById('IdentityUser', this.userMain.Id ).subscribe((data) => {
           
      this.Users = data;


      //console.log("Gotten User New ", this.userId, this.Users );


      let getUser = this.Users.find(n => n.Id === this.userMain.Id);
       this.User = Object.assign({},getUser) ;

       if(this.User !== undefined)
       {
        //let 
        this.userUpdate.Id =  this.User.Id;
        this.userUpdate.id = this.User.Id;
        this.userUpdate.Email = this.User.Email;
        this.userUpdate.UserName = this.User.UserName;
        this.userUpdate.PhoneNo = this.User.PhoneNo;
        this.userUpdate.StaffName = this.User.StaffName;


         
        this.gatewayService.isLoading$.next(true);
        this.userUpdate.password = this.password;
    
        console.log("User for Update ", this.userUpdate);
         this.gatewayFacade.update("IdentityUser",[this.userUpdate], []);
   
         this.gatewayService.isLoading$.pipe(take(2)).subscribe((val) => {
   
          // console.log("Is Loading value ", val);
             if(val === false)
             {
               //this._router.navigate(['/auth/login'])
             }
   
        })





       }
     

        
    });

    

   }else{
     this.passwordMissMatch = true;
     // Show Message
   }
 }else{

   Swal.fire(
     'No Password!',
     'Please enter password to continue.',
     'warning'
   );
 }

  
   }

}
